import trackError from "src/lib/track-error";
import convertPenceToPounds from "src/lib/convert-pence-to-pounds";
import { pushGTMEvent } from "src/analytics/events/gtm-event.js";

export default function trackGiftTransaction(data) {
  try {
    const {
      currency,
      transactionId,
      transactionTotal,
      transactionProducts,
    } = data;
    const transactionTotalInPounds = convertPenceToPounds(transactionTotal);
    const skus = transactionProducts.map((product) => product.sku);

    pushGTMEvent("pageviewGiftsThanks", {
      transactionTotal: transactionTotalInPounds,
      transactionProducts,
      transactionProductsSkus: skus,
      currency,
      transactionId,
    });

    if (typeof window.ga === "function") {
      window.ga("require", "ecommerce");
      window.ga("ecommerce:addTransaction", {
        id: transactionId,
        revenue: transactionTotalInPounds,
      });
      transactionProducts.map((product) =>
        window.ga("ecommerce:addItem", { ...product, ...{ id: transactionId } })
      );
      window.ga("ecommerce:send");
    }

    insertBlock(twitterTracking);
  } catch (error) {
    trackError({ errorMessage: "trackGiftTransaction", error });
  }
}

function insertBlock(content) {
  const div = document.createElement("div");
  div.innerHTML = content;
  document.body.appendChild(div);
}

const twitterTracking = `
<script src="//platform.twitter.com/oct.js"></script>
<script>twttr.conversion.trackPid('l4n8c');</script>`;
